
/* injects from baggage-loader */

'use strict';

/**
 * Interceptor of the http request for show loader when start transaction and hide when end.
 *
 * @export
 * @param {any} app
 */
export default function (app) {
	app.factory('httpInterceptor', httpInterceptor);

	/**
 	 * Interceptor of the http request for show loader when start transaction and hide when end.
	 *
	 * @param {any} $q
	 * @param {any} $rootScope
	 * @returns
	 */
	function httpInterceptor($q, $rootScope) {
		'ngInject';

		let numLoadings = 0;

		let service = {
			request: request,
			response: response,
			responseError: responseError
		};

		return service;

		/**
		 * Start http transaction.
		 *
		 * @param {any} config
		 * @returns
		 */
		function request(config) {
			numLoadings++;

			// Show loader
			$rootScope.$emit("loader_show");
			return config || $q.when(config);
		}

		/**
		 * End http transaction with ok status.
		 *
		 * @param {any} responseObj
		 * @returns
		 */
		function response(responseObj) {
			if ((--numLoadings) === 0) {
				// Hide loader
				$rootScope.$emit("loader_hide");
			}

			return responseObj || $q.when(responseObj);
		}

		/**
		 * End http transaction with error status.
		 *
		 * @param {any} responseObj
		 * @returns
		 */
		function responseError(responseObj) {
			if (!(--numLoadings)) {
				// Hide loader
				$rootScope.$emit("loader_hide");
			}

			return $q.reject(responseObj);
		}

	}
}



// WEBPACK FOOTER //
// ./src/app/core/services/interceptor.factory.js